export enum BADGE_TYPE {
    PREMIUM = 'premium',
    BASIC = 'basic'
}
